import React from 'react';

const Loadable = React.lazy(() => import('../../../pages/StatsFeature/SeoSuite/SeoSuite'));

export default Loadable;
